import { Spinner } from 'construct-ui';
import moment from 'moment';
import { messageComponent, messageType } from '../components/message/message.component';
import { formats as FORMATS } from '../config/constants';
import { apiStatusCodes } from '../config/global-variables';
import languageModel from '../models/language.model';
import loginModel from '../models/login.model';
import modelBaseV2 from '../models/model-base-v2.model';

export default function ViewBase() {

    this._isLoading = false;
    this._showMsg = false;
    this._message = "";
    this._title = undefined;
    this._messageType = "";
    this.messages = [];
    this._pendingOnClose = null;
    this._pendingOnAction = null;
    this.state = null;

    this.routeTo = (href) => {
        let continueRouting = dispatchEvent(new CustomEvent('route', {
            bubbles: false,
            cancelable: true
        }));

        if (continueRouting) {
            modelBaseV2.abortAllRequest();
            m.route.set(href);
        }
    }

    this.initState = (_state) => this.state = _state;

    this._showMsgIfAny = () => {
        if (this.messages.length > 0) {
            this._showMsg = true;
            this._message = this.messages[0].message;
            this._title = this.messages[0].title;
            this._messageType = this.messages[0].messageType;
            if (this.messages[0].onClose && typeof this.messages[0].onClose === 'function') {
                this._pendingOnClose = this.messages[0].onClose;
            } else {
                this._pendingOnClose = null;
            }
            if (this.messages[0].onAction && typeof this.messages[0].onAction === 'function') {
                this._pendingOnAction = this.messages[0].onAction;
            } else {
                this._pendingOnAction = null;
            }
            this.messages.splice(0, 1);
        } else {
            this._showMsg = false;
        }
    }
    this._allowOnlyNumbers = (e) => {
        if ((e.key <= 9 && e.key >= 0) || e.key == "Backspace" || e.key == "Delete") {
            return true;
        }
        else {
            return false;
        }
    }
    this._onMsgAction = (e) => {
        this._showMsgIfAny();
        if (this._pendingOnAction && typeof this._pendingOnAction === 'function') {
            this._pendingOnAction(e);
        }
    }
    this._onMsgClosed = (e) => {
        this._showMsgIfAny();
        if (this._pendingOnClose && typeof this._pendingOnClose === 'function') {
            this._pendingOnClose(e);
        }
    }
    this._showMessage = (msg) => {
        this.messages.push(msg);
        if (!this._showMsg) {
            this._showMsgIfAny();
        }
    }
    this.showConfirm = (message, title, onAction) => {
        title = title || this.getText("LT00000043", "Confirm");
        var msg = { message: message, title: title, onAction: onAction, messageType: messageType.CONFIRM };
        this._showMessage(msg);
    }
    this.showErrorMessage = (message, title, onClose) => {
        title = title || this.getText("EM00000142", "Error");
        var msg = { message: message, title: title, onClose: onClose, messageType: messageType.ERROR };
        this._showMessage(msg);
    }
    this.showWarningMessage = (message, title, onClose) => {
        title = title || this.getText("EM00000143", "Warning");
        var msg = { message: message, title: title, onClose: onClose, messageType: messageType.WARNING };
        this._showMessage(msg);
    }
    this.showMessage = (message, title, onClose) => {
        title = title || this.getText("EM00000146", "Message");
        var msg = { message: message, title: title, onClose: onClose, messageType: messageType.INFORMATION };
        this._showMessage(msg);
    }
    this.showLoading = () => {
        this._isLoading = true;
    }
    this.hideLoading = () => {
        this._isLoading = false;
    }

    this.getSpinner = () => {
        return this._isLoading && m(Spinner, {
            active: this._isLoading,
            background: true,
            fill: true,
            size: 'xl',
        });
    };

    this.getMessageComponent = () => {
        const urlParams = m.route.param();
        return this._showMsg && m(messageComponent, {
            isOpen: this._showMsg,
            onClosed: this._onMsgClosed,
            onAction: this._onMsgAction,
            message: this._message,
            title: this._title,
            msgType: this._messageType,
            urlParams: urlParams
        })
    };

    this.getBaseViews = () => {
        return [this.getSpinner(), this.getMessageComponent()];
    };

    this.handleError = (error) => {
        if (error?.code) {
            switch (error.code) {
                case apiStatusCodes.unauthorized:
                    this.showErrorMessage(this.getText("EM00000145", "Session Expired. Please login and try again."), this.getText("EM00000142", "Error"), () => {
                        m.route.set("/");
                    });
                    break;
                case apiStatusCodes.notFound:
                    this.showErrorMessage(this.getText("EM00000141", "No records found."));
                    break;
                case apiStatusCodes.badRequest:
                    console.error(JSON.parse(JSON.stringify(error)));
                    if (error.response && error.response.length > 0) {
                        if (error.response[0].code) {
                            this.showErrorMessage(this.getText(error.response[0].code, error.response[0].message));
                            break;
                        }
                    }
                    this.showErrorMessage(this.getText("EM00000140", "Invalid data submitted. Please check form data."));
                    break;
                case apiStatusCodes.forbidden:
                    this.showErrorMessage(this.getText("EM00000753", "User has no access."));
                    break;
                case apiStatusCodes.noContent:
                    // this.showErrorMessage("");
                    break;
                default:
                    console.error(JSON.parse(JSON.stringify(error)));
                    this.showErrorMessage(this.getText("EM00000138", "Server error. Please contact administrator."));
                    break;
            }
        } else if (typeof error === 'string' || error instanceof String) {
            this.showErrorMessage(error || "Please contact administrator", "Unexpected Error");
        } else {
            this.showErrorMessage("Please contact administrator", "Unexpected Error");
            console.error(JSON.parse(JSON.stringify(error)));
        }
    }
    this.dateFormat = (date, format) => {
        if (date == undefined) {
            return "";
        }
        format = format || "yyyy.MM.dd";
        if (format == "yyyyMMdd") {
            return '' + date.getFullYear() + '' + (date.getMonth() + 1).toString().padStart(2, "0") + (date.getDate()).toString().padStart(2, "0");
        }
        else if (format == "yyyy.MM.dd tt") {
            return '' + date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, "0") + '.' + (date.getDate()).toString().padStart(2, "0") + ' ' + date.toLocaleTimeString();
        }
        else if (format == "yyyyMMdd_tt") {
            return '' + date.getFullYear() + (date.getMonth() + 1).toString().padStart(2, "0") + (date.getDate()).toString().padStart(2, "0") + '_' + date.toLocaleTimeString();
        }
        return '' + date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, "0") + '.' + (date.getDate()).toString().padStart(2, "0");
    }

    this.dateStringFormat = (dateString, stringFormat = 'YYYY.MM.DD') => {
        if (!dateString || dateString.length < 1) {
            return "";
        }

        if (!moment(dateString, Object.values(FORMATS)).isValid()) {
            console.error("Invalid date: " + dateString);
            return "";
        }

        return moment(dateString, Object.values(FORMATS)).format(stringFormat);
    }

    this.getText = (code, defaultText) => {
        return languageModel.getText(code, defaultText);
    }
    this.getCountry = () => {
        if (loginModel != null && loginModel.credentials != null && loginModel.credentials.country != null) {
            return loginModel.credentials.country;
        } else {
            return null;
        }
    }
    this.spacer = (space) => {
        if (!space) space = 1;
        return [...Array(space)].map(x => m("span", "\u00A0"));
    }

    this.validateForm = (event, formSelector = '.needs-validation') => {
        event?.preventDefault();

        // Form validation
        let form = document.querySelector(formSelector);
        form.classList.add('was-validated');

        if (!form.checkValidity()) {
            event?.stopPropagation();
            return false;
        }
        return true;
    }

} 